var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Dashboard")]),_c('hr'),_c('Commands'),(!_vm.loading)?_c('div',{staticClass:"grid-wrapper dashboard-grid"},[_c('PanelOverview',{attrs:{"overview":_vm.dashboard.overview}})],1):_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }